"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANDING_ATTRIBUTION_PARAMS = void 0;
exports.stripLandingAttribution = stripLandingAttribution;
/**
 * Per-landing attribution papi-core stamps on the inbound link. They describe
 * how the user reached THIS page, so carrying them from the page URL into the
 * next search would log it as another RSoC / AYLF / Yahoo-CTA landing
 * (ABE-986, ABE-983). Server-built URLs (a unit's action_url, a result's
 * clickUrl) set their own and must not be stripped.
 */
exports.LANDING_ATTRIBUTION_PARAMS = [
    "serp_source",
    "aylf_query",
    "aylf_backend",
    "is_rsoc_url",
    "is_yahoo_cta_url",
];
/** Removes {@link LANDING_ATTRIBUTION_PARAMS} from `params` in place. */
function stripLandingAttribution(params) {
    for (const key of exports.LANDING_ATTRIBUTION_PARAMS)
        params.delete(key);
}
